<div id="content">
  <div class="detail-header">
    <div>
      <h1>Periodo {{ month_label() }}</h1>
      @if (company_product_title()) {
        <p class="subtitle">{{ company_product_title() }}</p>
      }
    </div>
    <div class="header-actions">
      <button mat-flat-button color="accent" type="button" (click)="navigateToConciliation()">Ir a conciliación</button>
      <a mat-stroked-button class="back-button" [routerLink]="list_back_link()" [queryParams]="back_query_params()">
        <mat-icon>arrow_back</mat-icon>
        Volver al listado
      </a>
    </div>
  </div>

  @if (is_loading()) {
    <p>Cargando periodo...</p>
  } @else if (report()) {
    <section class="summary-section">
      <div class="summary-item">
        <span class="label">Horas esperadas</span>
        <span class="value">{{ report()!.hours_expected_to_register_at_start_of_month ?? '—' }}h</span>
      </div>
      <div class="summary-item">
        <span class="label">Horas registradas</span>
        <span class="value">{{ report()!.hours_registered_at_end_of_month ?? '—' }}h</span>
      </div>
      <div class="summary-item">
        <span class="label">Horas conciliadas</span>
        <span class="value">{{ report()!.ro_total_hours_billed ?? 0 }}h</span>
      </div>
      <div class="summary-item">
        <span class="label">Importe conciliado</span>
        <span class="value">{{ report()!.ro_total_amount_billed ?? 0 | currency: 'EUR' }}</span>
      </div>
    </section>

    <section class="comment-section">
      <h2>Comentario</h2>
      @if (is_editing_comment()) {
        <mat-form-field appearance="outline" class="comment-field">
          <mat-label>Comentario</mat-label>
          <textarea matInput rows="3" [formControl]="comment_control"></textarea>
        </mat-form-field>
        <div class="comment-actions">
          <button mat-button type="button" (click)="cancelEditingComment()">Cancelar</button>
          <button mat-flat-button color="primary" type="button" [disabled]="is_saving_comment()" (click)="saveComment()">Guardar</button>
        </div>
      } @else {
        <p class="comment-text">{{ report()!.comment?.trim() || 'Sin comentario.' }}</p>
        @if (can_edit_comment()) {
          <button mat-stroked-button type="button" (click)="startEditingComment()">Editar comentario</button>
        }
      }
    </section>

    <section class="conciliations-section">
      <h2>Conciliaciones</h2>
      <table mat-table [dataSource]="conciliations_data_source()">
        <ng-container matColumnDef="invoice_number">
          <th mat-header-cell *matHeaderCellDef>Factura</th>
          <td mat-cell *matCellDef="let row; dataSource: conciliations_data_source()">{{ row.invoice_number }}</td>
        </ng-container>
        <ng-container matColumnDef="invoice_line">
          <th mat-header-cell *matHeaderCellDef>Línea</th>
          <td mat-cell *matCellDef="let row; dataSource: conciliations_data_source()" class="invoice-line-cell">
            {{ row.invoice_line_label }}
          </td>
        </ng-container>
        <ng-container matColumnDef="invoice_date">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let row; dataSource: conciliations_data_source()">{{ row.invoice_date_label }}</td>
        </ng-container>
        <ng-container matColumnDef="hours">
          <th mat-header-cell *matHeaderCellDef>Horas</th>
          <td mat-cell *matCellDef="let row; dataSource: conciliations_data_source()">{{ row.hours_conciliated_label }}</td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Importe</th>
          <td mat-cell *matCellDef="let row; dataSource: conciliations_data_source()">{{ row.amount_conciliated_label }}</td>
        </ng-container>
        <ng-container matColumnDef="comment">
          <th mat-header-cell *matHeaderCellDef>Comentario</th>
          <td mat-cell *matCellDef="let row; dataSource: conciliations_data_source()">{{ row.comment_label }}</td>
        </ng-container>
        <ng-container matColumnDef="origin">
          <th mat-header-cell *matHeaderCellDef>Origen</th>
          <td mat-cell *matCellDef="let row; dataSource: conciliations_data_source()">
            <span [class.origin-automatic]="row.is_automatic" [class.origin-manual]="!row.is_automatic">{{ row.user_label }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row; dataSource: conciliations_data_source()">
            @if (row.can_delete) {
              <button mat-icon-button type="button" aria-label="Desconciliar" (click)="deleteConciliation(row.id)">
                <mat-icon>delete</mat-icon>
              </button>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayed_columns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayed_columns"></tr>
      </table>
    </section>
  }
</div>
